import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const miwiModLegacyAuthEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('miwiModLegacyAuth'),
)

export default miwiModLegacyAuthEnabledSelector
